import React, { useContext } from 'react';
import styled from 'styled-components';
import { RichText } from 'prismic-reactjs';

import LanguageContext from '../../context/LangContext';

const Container = styled.div`
  background: #EBEBEB;
  margin-top: 30px;
`;

const SectionTitle = styled.span`
  color: #F1A857;
  font-size: 18px;
  padding: 14px 16px;
  display: block;
  font-weight: 600;
`

const Block = styled.div`
  width: 100%;
  display: flex;
  border-top: 1px solid #DEDEDE;
  padding: 14px 16px;
  font-size: 14px;
  box-sizing: border-box;
  &.last {
    padding-bottom: 44px;
  }
  p {
    margin: 0 0 10px;
  }
  a {
    border: 3px solid #F1A857;
    border-radius: 3px;
    height: 55px;
    display: block;
    width: 100%;
    display: flex;
    align-items: center;
    text-decoration: none;
    transition: all 0.3s;
    &:hover {
      background: #F1A857;
      .icone {
        border-color: #E0933D;
      }
      .texto {
        color: #fff;
      }
    }
    .icone {
      border-right: 1px solid #F1A857;
      width: 78px;
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100%;
      margin-right: 20px;
      i {
        height: 30px;
        width: 30px;
        background-size: contain;
        background-position: center;
        background-repeat: no-repeat;
        background-image: url(/images/streamline-icon-image-file-download@140x140-black.png);
      }
    }
    .texto {
      align-items: center;
      display: flex;
      font-size: 14px;
      color: #6A6A6A;
      letter-spacing: 0.31px;
    }
  }
`

const Title = styled.strong`
  font-size: 14px;
  padding-right: 10px;
`

const BoxInformacoesTecnicas = ({informacoes_tecnicas, informacoes_tecnicas_download}) => {
  const { language } = useContext(LanguageContext);
  let informacoesTecnicas = ''
  let download = ''
  switch (language) {
    case 'pt-br':
      informacoesTecnicas = 'Informações Técnicas';
      download = 'Baixar informações completas';
      break;
    case 'en-us':
      informacoesTecnicas = 'Technical information';
      download = 'Download complete information';
      break;
    case 'es-es':
      informacoesTecnicas = 'Informaciones técnicas';
      download = 'Descarga la información completa';
      break;
    default:
  }
  return (
    <Container>
      <SectionTitle>{ informacoesTecnicas }</SectionTitle>
      {
        informacoes_tecnicas.map((item, index) => {
          return (
            <Block key={ index }>
              <Title>{item.nome1}</Title>
              <div>
                { RichText.render(item.texto) }
              </div>
            </Block>
          )
        })
      }
      <Block className="last">
        <a href={ informacoes_tecnicas_download.url } target="_blank" rel="noopener noreferrer">
          <span className="icone">
            <i></i>
          </span>
          <span className="texto">
            { download }
          </span>
        </a>
      </Block>
    </Container>
  );
}

export default BoxInformacoesTecnicas;
